import {
    Button, Row, Col,
    Tooltip, Card, Divider, Modal, Skeleton,
    Checkbox
} from 'antd'
import React, { useRef, useState } from 'react'
import '../index.css'
import { ClearOutlined, HistoryOutlined, SearchOutlined } from '@ant-design/icons';
import API_ROUTES from '../../../api';
import axios from 'axios';
import EchartsComponent from '../SearchTwo/EchartsComponent';


export function SearchReference({ resultInfo }) {
    return (
        <>
            <Col xs={20} sm={20} className="detail-section-divider">
                <Divider />
            </Col>
            <Col xs={20} sm={20} className="detail-section-block">
                <span className='title_name' style={{ display: 'flex', alignItems: 'center', fontWeight: '700' }}>
                    <img src='https://gsrd-server.tos-cn-beijing.volces.com/gene10.png'
                        style={{ height: '30px', width: '30px', marginRight: '10px' }}
                    />
                    Reference
                </span>
                {/* 文献引用独立成详情页底部模块，宽度与上方详情内容保持一致 */}
                <div className="reference-card">
                    <span className="reference-label">PubMed references</span>
                    <div className="reference-links">
                        {(() => {
                            if (!resultInfo?.VEP_PUBMED) return <span className="reference-empty">No references available</span>;

                            // 真实VEP_PUBMED可能使用&、逗号或竖线连接，只提取有效数字PMID
                            const uniqueIds = Array.from(new Set(
                                resultInfo.VEP_PUBMED.match(/\d+/g) || []
                            ));

                            if (uniqueIds.length === 0) return <span className="reference-empty">No references available</span>;

                            return uniqueIds.map((id) => (
                                <a
                                    key={id}
                                    href={`https://pubmed.ncbi.nlm.nih.gov/${id}/`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    PMID {id}
                                </a>
                            ));
                        })()}
                    </div>
                </div>
            </Col>
        </>
    )
}


export default function SearchOne({ resultInfo }) {

    const [yangyeDetail, setYangyeDetail] = useState()
    const [searchLoading, setSearchLoading] = useState(false)
    const [selectParams, setSelectParams] = useState()
    const [expandedParamGroups, setExpandedParamGroups] = useState({})
    const [queryHistory, setQueryHistory] = useState([])
    const [activeHistoryId, setActiveHistoryId] = useState()
    const resultPanelRef = useRef(null)

    const nations = [
        // Ethnicity 按用户提供的新样本量顺序展示，value 保持接口所需 eth 编码不变
        { label: 'Han', value: "eth29" },
        { label: 'Tibetan', value: "eth40" },
        { label: 'Yi', value: "eth18" },
        { label: 'Miao', value: "eth38" },
        { label: 'Zhuang', value: "eth15" },
        { label: 'Hui', value: "eth11" },
        { label: 'Dongxiang', value: "eth1" },
        { label: 'Dong', value: "eth4" },
        { label: 'Bai', value: "eth34" },
        { label: 'Tujia', value: "eth13" },
        { label: 'Uyghur', value: "eth36" },
        { label: 'Bouyei', value: "eth16" },
        { label: 'Li', value: "eth48" },
        { label: 'Manchu', value: "eth30" },
        { label: 'Mongolian', value: "eth39" },
        { label: 'Bao\'an', value: "eth6" },
        { label: 'Yao', value: "eth32" },
        { label: 'Gelao / Mulao', value: "eth2" },
        { label: 'Kazakh', value: "eth10" },
        { label: 'Yugur', value: "eth41" },
        { label: 'Qiang', value: "eth37" },
        { label: 'Lisu', value: "eth7" },
        { label: 'Korean', value: "eth25" },
        { label: 'De\'ang', value: "eth19" },
        { label: 'Jingpo', value: "eth24" },
        { label: 'Shui', value: "eth28" },
        { label: 'Tu', value: "eth12" },
        { label: 'Kyrgyz', value: "eth26" },
        { label: 'Hani', value: "eth9" },
        { label: 'She', value: "eth33" },
        { label: 'Tajik', value: "eth14" },
        { label: 'Naxi', value: "eth35" },
        { label: 'Dai', value: "eth8" },
        { label: 'Daur', value: "eth42" },
        { label: 'Maonan', value: "eth27" },
        { label: 'Derung', value: "eth31" },
        { label: 'Achang', value: "eth46" },
        { label: 'Salar', value: "eth22" },
        { label: 'Xibe', value: "eth44" },
        { label: 'Va', value: "eth3" },
        { label: 'Russian', value: "eth5" },
        { label: 'Pumi', value: "eth23" },
        { label: 'Lahu', value: "eth21" },
        { label: 'Menba', value: "eth45" },
        { label: 'Blang', value: "eth17" },
        { label: 'Nu', value: "eth20" },
        { label: 'Ewenki', value: "eth43" },
        { label: 'Gaoshan', value: "eth47" }
    ];

    //地域选项 已删除other选项
    const regions = [
        { label: 'Central China', value: "CC" },
        { label: 'East China', value: "EC" },
        { label: 'North China', value: "NC" },
        { label: 'Northeast China', value: "NE" },
        { label: 'Northwest China', value: "NW" },
        { label: 'South China', value: "SC" },
        { label: 'Southwest China', value: "SW" }
    ];
    // 表型筛选分为非罕见病和罕见病两组，提交时仍使用统一编码数组
    const nonRareDiseases = [
        { label: 'Natural population', value: "phenaturalpopulation" },
        { label: 'Family unaffected', value: "phefamilyunaffected" }
    ];
    const rareDiseases = [
        // Rare disease group 不再展示 Unknown，避免和 Age/Sex 的 Unknown 语义混淆
        { label: 'Ear-related disorders', value: "phe0001" },
        { label: 'Neurological disorders', value: "phe0002" },
        { label: 'Genitourinary system disorders', value: "phe0003" },
        { label: 'Dermatological disorders', value: "phe0004" },
        { label: 'Musculoskeletal disorders', value: "phe0005" },
        { label: 'Genetic related tumors', value: "phe0006" },
        { label: 'Hematological and immunological disorders', value: "phe0007" },
        { label: 'Metabolic & homeostatic disorders', value: "phe0008" },
        { label: 'Orofacial deformities', value: "phe0009" },
        { label: 'Cardiovascular system disorders', value: "phe0010" },
        { label: 'Ocular disorders', value: "phe0011" },
        { label: 'Fetal intrauterine developmental disorders', value: "phe0012" },
        { label: 'Gastrointestinal disorders', value: "phe0013" },
        { label: 'Endocrine system disorders', value: "phe0014" },
        { label: 'Respiratory system disorders', value: "phe0015" },
        { label: 'Ultra-rare disorders', value: "phe0016" }
    ];
    const diseases = [...nonRareDiseases, ...rareDiseases];


    // 年龄直接对应新版type=1文件中的age编码，避免滑块区间转换造成歧义
    const ages = [
        { label: '0 - 6', description: 'Early childhood', value: 'age1' },
        { label: '6 - 18', description: 'Child & adolescent', value: 'age2' },
        { label: '18 - 50', description: 'Adult', value: 'age3' },
        { label: '50+', description: 'Older adult', value: 'age4' },
        { label: 'Unknown', description: 'Age unavailable', value: 'age0' }
    ];
    const genders = [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
        { label: 'Unknown', value: 'U' }
    ];

    const [selectedAges, setSelectedAges] = useState([]);
    const [dieseaseSearch, setDieaseSearch] = useState([])
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [selectGender, setSelectGender] = useState([])
    const [selectNation, setSelectNation] = useState([])

    // 将已提交编码转换为便于阅读的筛选条件摘要
    const getSelectedLabels = (selectedValues, options) => selectedValues
        .map(value => options.find(item => item.value === value)?.label)
        .filter(Boolean);

    const buildQueryParams = () => ({
        gender: [...selectGender],
        nation: [...selectNation],
        age: [...selectedAges],
        disease: [...dieseaseSearch],
        region: [...selectedRegions]
    });

    // 查询前必须保证每个维度至少选择一个条件，避免提交空维度导致结果含义不明确
    const validateFilterSelections = () => {
        const missingGroups = [];
        if (selectedRegions.length === 0) missingGroups.push('Region');
        if (selectedAges.length === 0) missingGroups.push('Age');
        if (selectGender.length === 0) missingGroups.push('Sex');
        if (selectNation.length === 0) missingGroups.push('Ethnicity');
        if (dieseaseSearch.length === 0) missingGroups.push('Disease / Control Group');

        if (missingGroups.length > 0) {
            Modal.warning({
                content: `Please select at least one option for: ${missingGroups.join(', ')}.`
            });
            return false;
        }
        return true;
    };

    const buildHistoryTitle = (params) => {
        const diseaseLabels = getSelectedLabels(params.disease, diseases);
        const nationLabels = getSelectedLabels(params.nation, nations);
        const diseaseText = diseaseLabels.length === diseases.length ? 'All disease/control groups' : `${diseaseLabels.length} disease/control groups`;
        const nationText = nationLabels.length === nations.length ? 'All ethnicities' : `${nationLabels.length} ethnicities`;
        return `${nationText} · ${diseaseText}`;
    };

    // 一键清空所有 Group-specific Allele Frequencies 筛选条件，并同步清理旧查询回显
    const clearAllFilterSelections = () => {
        setSelectedRegions([]);
        setSelectedAges([]);
        setSelectGender([]);
        setSelectNation([]);
        setDieaseSearch([]);
        setSelectParams(undefined);
        setYangyeDetail(undefined);
        setExpandedParamGroups({});
        setActiveHistoryId(undefined);
    };

    // 查询结果展示在搜索条件下方；结果面板内部先展示统计结果，再展示条件回显
    const renderFilterResult = () => {
        if (!selectParams) return null;
        if (searchLoading) {
            return (
                <Col xs={20} sm={20}>
                    <Card style={{ backgroundColor: 'aliceblue', padding: '2px 10px' }} >
                        <Skeleton active paragraph={{
                            rows: 9,
                        }} />
                    </Card>
                </Col>
            );
        }

        const activeHistory = queryHistory.find(item => item.id === activeHistoryId);
        const displayDetail = activeHistory?.result || yangyeDetail;
        const displayParams = activeHistory?.params || selectParams;

        const resultGroups = [
            { title: 'Gender', values: getSelectedLabels(displayParams.gender, genders) },
            { title: 'Age groups', values: getSelectedLabels(displayParams.age, ages) },
            { title: 'Regions', values: getSelectedLabels(displayParams.region, regions) },
            { title: 'Ethnicity', values: getSelectedLabels(displayParams.nation, nations) },
            { title: 'Disease / Control Group', values: getSelectedLabels(displayParams.disease, diseases), wide: true }
        ];

        const metricCards = [
            {
                title: 'Allele Frequency',
                value: displayDetail?.an ? (displayDetail?.ac / displayDetail?.an).toFixed(4) : 0,
                note: 'AC / AN',
                featured: true,
                tooltip: 'Alternate allele frequency in high quality genotypes'
            },
            {
                title: 'Allele Count',
                value: displayDetail?.ac ?? 0,
                note: 'Alternate alleles',
                tooltip: 'Alternate allele count in high quality genotypes'
            },
            {
                title: 'Allele Number',
                value: displayDetail?.an ?? 0,
                note: 'Called alleles',
                tooltip: 'Total number of called high quality genotypes'
            },
            {
                title: 'Homozygotes hom_alt',
                value: displayDetail?.homAlt ?? 0,
                note: 'Alternate genotype',
                tooltip: 'Number of individuals homozygous for alternate allele'
            },
            {
                title: 'Hemizygotes hemi_ref',
                value: displayDetail?.hemiRef ?? 0,
                note: 'Reference hemizygotes',
                tooltip: 'Number of reference hemizygous individuals'
            },
            {
                title: 'Hemizygotes alt',
                value: displayDetail?.hemizygot ?? 0,
                note: 'Alternate hemizygotes',
                tooltip: 'Number of alternate hemizygous individuals'
            },
            {
                title: 'Individuals with > 30x coverage',
                value: '100%',
                note: 'Coverage quality',
                tooltip: "Fraction of individuals with >30x coverage at this variant's locus"
            }
        ];

        return (
            <Col xs={20} sm={20} ref={resultPanelRef}>
                <Card className="search-filter-result-card">
                    <div className="result-overview-header">
                        <div>
                            {/* 结果标题按用户要求简化，只保留选中人群等位基因摘要名称 */}
                            <h3>Selected Group Allele Summary </h3>
                        </div>
                    </div>

                    <div className="result-history-layout">
                        <div className="result-main-column">
                        {/* 查询结果使用重点指标卡，突出频率并区分不同统计类型 */}
                            <div className="filter-metric-grid result-metric-grid">
                                {metricCards.map(metric => (
                                    <Tooltip placement="top" title={metric.tooltip} key={metric.title}>
                                        <div className={`filter-metric-card ${metric.featured ? 'featured' : ''}`}>
                                            <span>{metric.title}</span>
                                            <strong>{metric.value}</strong>
                                            <small>{metric.note}</small>
                                        </div>
                                    </Tooltip>
                                ))}
                            </div>

                            {/* 已提交参数使用紧凑摘要条，避免回显条件占用过多篇幅 */}
                            <div className="result-parameter-strip">
                                {resultGroups.map(group => {
                                    const isExpanded = !!expandedParamGroups[group.title];
                                    const previewValues = isExpanded ? group.values : group.values.slice(0, 4);
                                    return (
                                        <div className={`result-parameter-item ${isExpanded ? 'expanded' : ''}`} key={group.title}>
                                            <div className="result-parameter-item-head">
                                                <span>{group.title}</span>
                                                <button
                                                    type="button"
                                                    onClick={() => setExpandedParamGroups(prev => ({
                                                        ...prev,
                                                        [group.title]: !prev[group.title]
                                                    }))}
                                                >
                                                    {isExpanded ? 'Collapse' : `${group.values.length} selected`}
                                                </button>
                                            </div>
                                            <div className="result-parameter-preview">
                                                {group.values.length > 0
                                                    ? previewValues.map(value => <span key={value}>{value}</span>)
                                                    : <em>No selection</em>}
                                                {!isExpanded && group.values.length > 4 &&
                                                    <button
                                                        type="button"
                                                        className="result-parameter-more"
                                                        onClick={() => setExpandedParamGroups(prev => ({
                                                            ...prev,
                                                            [group.title]: true
                                                        }))}
                                                    >
                                                        +{group.values.length - 4}
                                                    </button>}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        <aside className="query-history-panel">
                            <div className="query-history-heading">
                                <HistoryOutlined />
                                <span>Query history</span>
                            </div>
                            <div className="query-history-list">
                                {queryHistory.map((item, index) => {
                                    const af = item.result?.an ? (item.result?.ac / item.result?.an).toFixed(4) : 0;
                                    return (
                                        <button
                                            type="button"
                                            key={item.id}
                                            className={`query-history-item ${item.id === activeHistoryId ? 'active' : ''}`}
                                            onClick={() => {
                                                setActiveHistoryId(item.id);
                                                setExpandedParamGroups({});
                                            }}
                                        >
                                            <span className="query-history-index">#{queryHistory.length - index}</span>
                                            <span className="query-history-main">
                                                <strong>{item.title}</strong>
                                                <small>{item.createdAt}</small>
                                            </span>
                                            <span className="query-history-af">{af}</span>
                                        </button>
                                    );
                                })}
                            </div>
                        </aside>
                    </div>
                </Card>
                {resultInfo === "chr13:20189473-C-T" &&
                    <Card>
                        <iframe src="http://101.126.24.36:3000/jbrowse/?config=ncaw%2Fconfig.json&assembly=hg19&loc=chr13:20184473..20194473&tracks=genecode_GRCh38,WBBC_Chinese_GRCh38,HRC_European_hg19Tohg38,jMorp_GRCh38_Japanese_norm,gnomAD_GRCh38,ChinaMAP_Chinese_GRCh38,dbSNP_freq_GRCh38"
                            style={{ height: "800px", width: "100%", border: "0px" }} />
                    </Card>
                }
            </Col>
        );
    };

    return (
        <Row style={{ width: '100%' }} justify={'center'} className="search-filter-section">
            <Col xs={20} sm={20}>
                {resultInfo === "chr13:20189473-C-T" &&
                    <Card style={{
                        display: 'flex',
                        alignItems: 'center',
                        border: '0px',
                        justifyContent: 'center'
                    }}>
                        <img src={"https://gsrd-server.tos-cn-beijing.volces.com/search7.png"} />
                    </Card>
                }
            </Col>
            <Col xs={20} sm={20}>
                <Divider />
            </Col>
            <Col xs={20} sm={20}>
                <div className="search-filter-title-row">
                    <div className="search-filter-title-copy">
                        <span className='title_name' style={{ display: 'flex', alignItems: 'center', fontWeight: '700' }}>
                            <img src='https://gsrd-server.tos-cn-beijing.volces.com/gene9.png'
                                style={{ height: '30px', width: '30px', marginRight: '10px' }}
                            />
                            Group-specific Allele Frequencies
                        </span>
                        {/* 搜索区说明：提示用户可通过自定义人群条件查看对应频率 */}
                        <p className="search-section-description">
                            Select subgroups to calculate group-specific allele frequencies.
                        </p>
                    </div>
                    <Button
                        className="search-clear-filters-btn"
                        icon={<ClearOutlined />}
                        onClick={clearAllFilterSelections}
                    >
                        Clear all
                    </Button>
                </div>
            </Col>
            <Col xs={20} sm={20}>
                {/* 二次筛选区域按数据维度分组，区域选择保留地图与选项两种交互方式 */}
                <Card className="search-filter-card">
                    <div className="filter-workspace">
                        <section className="filter-panel region-filter-panel">
                            <div className="filter-panel-header">
                                <div>
                                    <h3>Region</h3>
                                </div>
                                <div className="filter-header-actions">
                                    <span>{selectedRegions.length} / {regions.length} selected</span>
                                    <Checkbox
                                        checked={selectedRegions.length === regions.length}
                                        indeterminate={selectedRegions.length > 0 && selectedRegions.length < regions.length}
                                        onChange={(e) => setSelectedRegions(e.target.checked ? regions.map(item => item.value) : [])}
                                    >
                                        Select all
                                    </Checkbox>
                                </div>
                            </div>
                            <div className="region-selector-layout">
                                <div className="region-selector-aside">
                                    <Checkbox.Group
                                        className="filter-option-grid region-option-grid"
                                        value={selectedRegions}
                                        onChange={setSelectedRegions}
                                    >
                                        {regions.map(item => (
                                            <Checkbox key={item.value} value={item.value}>{item.label}</Checkbox>
                                        ))}
                                    </Checkbox.Group>
                                    <div className="region-selection-note">
                                        <strong>{selectedRegions.length}</strong>
                                        <span>regions selected</span>
                                    </div>
                                </div>
                                <div className="region-map-wrap">
                                    <div className="region-map-tip">Click map regions to select or deselect</div>
                                    <EchartsComponent
                                        selectedRegions={selectedRegions}
                                        setSelectedRegions={setSelectedRegions}
                                    />
                                </div>
                            </div>
                        </section>

                        <div className="filter-compact-row">
                            <section className="filter-panel">
                                <div className="filter-panel-header compact">
                                    <div>
                                        <h3>Age</h3>
                                    </div>
                                    <div className="filter-header-actions">
                                        <span>{selectedAges.length} / {ages.length} selected</span>
                                        <Checkbox
                                            checked={selectedAges.length === ages.length}
                                            indeterminate={selectedAges.length > 0 && selectedAges.length < ages.length}
                                            onChange={(e) => setSelectedAges(e.target.checked ? ages.map(item => item.value) : [])}
                                        >
                                            Select all
                                        </Checkbox>
                                    </div>
                                </div>
                                <Checkbox.Group
                                    className="age-option-grid"
                                    value={selectedAges}
                                    onChange={setSelectedAges}
                                >
                                    {ages.map(item => (
                                        <Checkbox key={item.value} value={item.value}>
                                            {/* 年龄选项文字保持常规字重，并限制单项宽度避免溢出 */}
                                            <span className="age-option-label">{item.label}</span>
                                        </Checkbox>
                                    ))}
                                </Checkbox.Group>
                            </section>

                            <section className="filter-panel">
                                <div className="filter-panel-header compact">
                                    <div>
                                        <h3>Sex</h3>
                                    </div>
                                    <div className="filter-header-actions">
                                        <span>{selectGender.length} / {genders.length} selected</span>
                                        <Checkbox
                                            checked={selectGender.length === genders.length}
                                            indeterminate={selectGender.length > 0 && selectGender.length < genders.length}
                                            onChange={(e) => setSelectGender(e.target.checked ? genders.map(item => item.value) : [])}
                                        >
                                            Select all
                                        </Checkbox>
                                    </div>
                                </div>
                                <Checkbox.Group
                                    className="filter-option-grid gender-option-grid"
                                    value={selectGender}
                                    onChange={setSelectGender}
                                >
                                    {genders.map(item => (
                                        <Checkbox key={item.value} value={item.value}>{item.label}</Checkbox>
                                    ))}
                                </Checkbox.Group>
                            </section>
                        </div>

                        <section className="filter-panel wide-filter-panel">
                            <div className="filter-panel-header compact">
                                <div>
                                    <h3>Ethnicity</h3>
                                </div>
                                <div className="filter-header-actions">
                                    <span>{selectNation.length} / {nations.length} selected</span>
                                    <Checkbox
                                        checked={selectNation.length === nations.length}
                                        indeterminate={selectNation.length > 0 && selectNation.length < nations.length}
                                        onChange={(e) => setSelectNation(e.target.checked ? nations.map(item => item.value) : [])}
                                    >
                                        Select all
                                    </Checkbox>
                                </div>
                            </div>
                            <Checkbox.Group
                                className="filter-option-grid nation-option-grid"
                                value={selectNation}
                                onChange={setSelectNation}
                            >
                                {nations.map(item => (
                                    <Checkbox key={item.value} value={item.value}>{item.label}</Checkbox>
                                ))}
                            </Checkbox.Group>
                        </section>

                        <section className="filter-panel wide-filter-panel">
                            <div className="filter-panel-header compact">
                                <div>
                                    <h3>Disease / Control Group</h3>
                                </div>
                                <div className="filter-header-actions">
                                    <span>{dieseaseSearch.length} / {diseases.length} selected</span>
                                    <Checkbox
                                        checked={dieseaseSearch.length === diseases.length}
                                        indeterminate={dieseaseSearch.length > 0 && dieseaseSearch.length < diseases.length}
                                        onChange={(e) => setDieaseSearch(e.target.checked ? diseases.map(item => item.value) : [])}
                                    >
                                        Select all
                                    </Checkbox>
                                </div>
                            </div>
                            <Checkbox.Group
                                className="filter-option-grid disease-option-grid"
                                value={dieseaseSearch}
                                onChange={setDieaseSearch}
                            >
                                <div className="disease-category">
                                    <span className="disease-category-title">Control group</span>
                                    <div className="disease-category-options">
                                        {nonRareDiseases.map(item => (
                                            <Checkbox key={item.value} value={item.value}>{item.label}</Checkbox>
                                        ))}
                                    </div>
                                </div>
                                <div className="disease-category">
                                    <span className="disease-category-title">Rare disease group</span>
                                    <div className="disease-category-options">
                                        {rareDiseases.map(item => (
                                            <Checkbox key={item.value} value={item.value}>{item.label}</Checkbox>
                                        ))}
                                    </div>
                                </div>
                            </Checkbox.Group>
                        </section>
                    </div>

                    <div className="filter-submit-bar">
                        <div>
                            <strong>Selected groups</strong>
                            {/* 选中条件汇总补充 Sex 维度，方便和上方筛选项保持一致 */}
                            <span>{selectedRegions.length} regions · {selectedAges.length} age groups · {selectGender.length} sex groups · {selectNation.length} ethnicities · {dieseaseSearch.length} disease/control groups</span>
                        </div>
                        <Button
                            type="primary"
                            shape="round"
                            icon={<SearchOutlined />}
                            loading={searchLoading}
                            onClick={() => {
                                if (!validateFilterSelections()) {
                                    return;
                                }
                                setSearchLoading(true)
                                setYangyeDetail({})
                                const submittedParams = buildQueryParams();
                                axios.post(API_ROUTES.api_search_parseResultInfo, {
                                    id: resultInfo.searchInfo.id,
                                    gender: selectGender.join(","),
                                    nation: selectNation.join(","),
                                    age: selectedAges.join(","),
                                    disease: dieseaseSearch.join(","),
                                    region: selectedRegions.join(","),
                                }, {
                                    headers: {
                                        Authorization: localStorage.getItem('userInfo')
                                    }
                                })
                                    .then(function (response) {
                                        if (response.data.code === 500) {
                                            Modal.error({
                                                content: response.data.msg
                                            });
                                        } else {
                                            const nextResult = response.data.data;
                                            const nextRecord = {
                                                id: `${Date.now()}`,
                                                createdAt: new Date().toLocaleString(),
                                                title: buildHistoryTitle(submittedParams),
                                                params: submittedParams,
                                                result: nextResult
                                            };
                                            setYangyeDetail(nextResult)
                                            setSelectParams(submittedParams)
                                            setActiveHistoryId(nextRecord.id)
                                            // 历史结果仅保存在当前前端会话内，便于多次查询后快速对比查看
                                            setQueryHistory(prev => [nextRecord, ...prev].slice(0, 12))
                                            // 查询结果展示在筛选条件上方，成功后自动滚动到结果区域
                                            setTimeout(() => {
                                                resultPanelRef.current?.scrollIntoView({
                                                    behavior: 'smooth',
                                                    block: 'start'
                                                });
                                            }, 0);
                                        }
                                    })
                                    .catch(function () {
                                        Modal.error({
                                            content: "error"
                                        });
                                    })
                                    .finally(() => {
                                        setSearchLoading(false)
                                    });
                            }}
                        >
                            Calculate
                        </Button>
                    </div>
                </Card>
            </Col>
            {renderFilterResult()}
        </Row>
    )
}
